// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".price-view-dialog .el-dialog__body {\n  padding: 0px 5px 0px;\n  min-height: 650px;\n}\n.price-view-dialog .el-dialog__footer {\n  padding: 5px;\n}\n.price-view-dialog .el-form-item {\n  margin: 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
